/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeResponseDto } from './MeResponseDto';
import {
    MeResponseDtoFromJSON,
    MeResponseDtoFromJSONTyped,
    MeResponseDtoToJSON,
    MeResponseDtoToJSONTyped,
} from './MeResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface UserPaginationResponseDto
 */
export interface UserPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof UserPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<MeResponseDto>}
     * @memberof UserPaginationResponseDto
     */
    items: Array<MeResponseDto>;
}

/**
 * Check if a given object implements the UserPaginationResponseDto interface.
 */
export function instanceOfUserPaginationResponseDto(value: object): value is UserPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function UserPaginationResponseDtoFromJSON(json: any): UserPaginationResponseDto {
    return UserPaginationResponseDtoFromJSONTyped(json, false);
}

export function UserPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(MeResponseDtoFromJSON)),
    };
}

export function UserPaginationResponseDtoToJSON(json: any): UserPaginationResponseDto {
    return UserPaginationResponseDtoToJSONTyped(json, false);
}

export function UserPaginationResponseDtoToJSONTyped(value?: UserPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(MeResponseDtoToJSON)),
    };
}

